module.exports = __webpack_public_path__ + "static/media/cheps1.dfc0d025.jpg";